import { cardEl } from "./dom";

function createSetCardholderNamePreviewHandler() {
    let placeholderName = cardEl.cardholder.textContent;
    const setName = (name) => {
        cardEl.cardholder.textContent = name
    }

    return (newValue) => {
        if (newValue.length > 30) return;

        if (newValue === "") {
            setName(placeholderName)
            return
        }

        setName(newValue)
    }
}

function createSetCardNumberPreviewHandler() {
    const defaultValue = "0000 0000 0000 0000"
    const setNumber = (number) => {
        cardEl.cardNumber.textContent = number
    }

    // Adds a space after every 4 digits
    function transformNumberToCardNumber(number) {
        const length = number.length
        if (length <= 4) return number
        let transformedNumber = number[0].toString()

        for (let index = 1; index < length; index++) {
            if (index % 4 === 0) {
                transformedNumber += " "
            }

            transformedNumber += number[index]
        }

        return transformedNumber.trimEnd()
    }

    return (inputValue) => {
        const newValue = inputValue.replaceAll(" ", '')

        if (newValue.trim().length === 0) {
            setNumber(defaultValue)
            return
        }

        if (newValue.length > 16) {
            return
        }

        setNumber(transformNumberToCardNumber(newValue))
    }
}

function createSetExpireDatePreviewHandlers() {
    const setDateString = (date) => {
        cardEl.expireDate.textContent = date
    }
    const setMonth = (month) => {
        let monthToSet = ""
        if (month.length !== 2) {
            monthToSet = '0' + month.toString()
        }
        else {
            // :(
            monthToSet = month;
        }

        currentMonthString = monthToSet;
        updateDateDom()
    }
    const setYear = (year) => {
        currentYearString = year;
        updateDateDom()
    }

    // Updates dom values using current month and year values
    function updateDateDom() {
        setDateString(currentMonthString + '/' + currentYearString)
    }

    let currentMonthString = "00"
    let currentYearString = "00"

    function setMonthPreview(newValue) {
        if (newValue.trim().length === 0) {
            setMonth("00")
            return
        }

        setMonth(newValue)
    }

    function setYearPreview(newValue) {
        if (newValue.trim().length === 0) {
            setYear("00")
            return
        }

        setYear(newValue)
    }

    return { setMonthPreview, setYearPreview }
}

function createSetCvcPreviewHandler() {
    const setCode = (code) => {
        cardEl.cvc.textContent = code;
    }

    return (newValue) => {
        if (newValue.trim().length === 0) {
            setCode("000")
            return
        }

        if (newValue.length > 3) return

        setCode(newValue)
    }
}

const setCardholderNamePreview = createSetCardholderNamePreviewHandler()
const setCvcPreview = createSetCvcPreviewHandler()
const setCardNumberPreview = createSetCardNumberPreviewHandler()
const setExpireDatePreviewHandlers = createSetExpireDatePreviewHandlers()

function resetAllPreviews() {
    setCardNumberPreview("")
    setCardholderNamePreview("")
    setCvcPreview("")
    setExpireDatePreviewHandlers.setMonthPreview("")
    setExpireDatePreviewHandlers.setYearPreview("")
}

export {
    setCardholderNamePreview,
    setCardNumberPreview,
    setExpireDatePreviewHandlers,
    setCvcPreview,
    resetAllPreviews,
}